// extracted by mini-css-extract-plugin
export default {"menuButton":"PageMenuButton-menuButton-xRzLO MenuButton-menuButton-Jl5Je","indicatorContainer":"PageMenuButton-indicatorContainer-POVDu","label":"PageMenuButton-label-Jm2ou"};